import React, { useEffect, useState } from 'react';
import api from 'api/api';
import auth from 'utils/auth';
import Loader from 'ui/Loader/Loader';
import NoBeneficiary from 'components/modules/Beneficiaries/NoBeneficiary/NoBeneficiary';
import BeneficiaryTable from 'components/modules/Beneficiaries/BeneficiaryTable/BeneficiaryTable';
import BeneficiaryRow from 'components/modules/Beneficiaries/BeneficiaryTable/BeneficiaryRow/BeneficiaryRow';
import BeneficiaryCol from 'components/modules/Beneficiaries/BeneficiaryTable/BeneficiaryCol/BeneficiaryCol';
import EditPrepaidBulkBen from './EditPrepaidBulkBen';
import { IAPIBeneficiaryPrepaidBulk, IPrepaidBulkIds, ITransformedPrepaidBulkId } from './BulkPrepaidBen.model';

enum States {
  browsing = 'browsing',
  editing = 'editing',
}
function transformMobileBulkIds(bulkIds: IPrepaidBulkIds) {
  const keys = Object.keys(bulkIds);

  const result = keys.map((key) => {
    const item = bulkIds[key];
    return {
      id: key,
      alias: item.alias,
      count: item.count,
      beneficiaries: item.beneficiaries,
    };
  });

  return result;
}

const BulkPrepaidBen = () => {
  const [loadingData, setLoadingData] = useState(false);
  const [data, setData] = useState<ITransformedPrepaidBulkId[]>([]);
  const [editData, setEditData] = useState<ITransformedPrepaidBulkId | null>(null);

  const [state, setState] = useState<States>(States.browsing);

  const fetchBeneficiaries = () => {
    setLoadingData(true);
    api
      .get(`/beneficiary/prepaidcard/bulk?loginId=${auth.data?.loginId || ''}`)
      .then((response: IAPIBeneficiaryPrepaidBulk) => {
        const transformedBulkList: ITransformedPrepaidBulkId[] = transformMobileBulkIds(response.bulkIds);
        setData(transformedBulkList);
      })
      .catch((error) => {
        console.error(error);
        setData([]);
      })
      .finally(() => {
        setLoadingData(false);
      });
  };

  useEffect(() => {
    fetchBeneficiaries();
  }, []);

  const openEditForm = (e: React.MouseEvent<HTMLDivElement>) => {
    setState(States.editing);
    const object = data.find(({ id }) => id === e.currentTarget.id);
    if (object) {
      setEditData(object);
    }
  };

  const closeEditForm = () => {
    setState(States.browsing);
    fetchBeneficiaries();
  };

  if (state === States.editing && editData) {
    return <EditPrepaidBulkBen data={editData} onClose={closeEditForm} />;
  }

  const renderTable = () => (
    <BeneficiaryTable>
      {data.map((bulkBeneficiary) => (
        <BeneficiaryRow onClick={openEditForm} id={String(bulkBeneficiary.id)} key={bulkBeneficiary.id}>
          <BeneficiaryCol label="Bulk ID" value={bulkBeneficiary.id} width="20%" minWidth="240px" />
          <BeneficiaryCol
            label="Total Beneficiaries"
            value={String(bulkBeneficiary.count)}
            width="80%"
            minWidth="300px"
          />
        </BeneficiaryRow>
      ))}
    </BeneficiaryTable>
  );

  return (
    <>
      {loadingData && <Loader fullHeight />}
      {!loadingData && data.length === 0 && <NoBeneficiary />}
      {!loadingData && data.length > 0 && renderTable()}
    </>
  );
};

export default BulkPrepaidBen;
